import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { RolePermission } from '../types';

const Footer: React.FC = () => {
  const { user } = useAuth();
  const can = (permission: RolePermission) => !!user?.permissions?.includes(permission);
  const canCreate = can('create_discussions');
  const canViewQueue = can('view_unpublished_discussions');
  const canAccessOps = can('access_staff_operations');
  const canReviewReports = can('manage_weather_reports');

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <p className="eyebrow">GLSN</p>
          <h2 className="footer-title">Ops Dashboard</h2>
          <p className="footer-copy">
            Operational discussions, severe weather reports, and staff coordination for active weather workflows.
          </p>
          <p className="footer-copy">© Great Lakes Severe Network. Founded by ooDVG, 2026.</p>
        </div>

        <div>
          <h3 className="footer-heading">Public pages</h3>
          <div className="footer-links">
            <Link to="/">Home</Link>
            <Link to="/archive">Archive</Link>
            <Link to="/report">Report severe weather</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>

        <div>
          <h3 className="footer-heading">Staff tools</h3>
          <div className="footer-links">
            {canCreate || canViewQueue || canAccessOps || canReviewReports ? (
              <>
                {canAccessOps && <Link to="/staff/ops-center">Ops center</Link>}
                {canViewQueue && <Link to="/staff/drafts">Draft queue</Link>}
                {canReviewReports && <Link to="/staff/reports">Reports inbox</Link>}
                {canCreate && <Link to="/compose">Create discussion</Link>}
              </>
            ) : (
              <span className="footer-copy">Sign in with an authorized role to access internal operations pages.</span>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;